import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FlaskConical } from 'lucide-react';

import { isSandboxEnvironment } from '../../utils/environment';

// Test ortamı (REACT_APP_ENVIRONMENT=sandbox) şeridi — uygulama kabuğunda üst çubuğun hemen altında,
// KAPATILAMAZ: kullanıcı her ekranda sentetik veriyle çalıştığını ve verinin gece sıfırlandığını
// görmelidir. Canlı ortamda hiçbir şey çizmez.
//
// Kabuğun kaydırma düzeni bozulmaz: şerit içerik sütununda sabit yükseklikli bir satırdır
// (flex-shrink: 0); kayan tek alan yine <Main>'dir (min-height: 0).
export default function SandboxBanner() {
  const { t } = useTranslation();
  if (!isSandboxEnvironment()) return null;

  return (
    <Bar role="note" data-testid="sandbox-banner">
      <FlaskConical size={14} aria-hidden="true" />
      <span>{t('sandboxEnv.banner')}</span>
    </Bar>
  );
}

const Bar = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 5px 16px;
  background: #FFF8E6;
  border-bottom: 1px solid ${({ theme }) => theme.colors.auxiliar.warning};
  color: #7A5B00;
  font-family: ${({ theme }) => theme.metrics.font.family};
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  text-align: center;

  > svg { flex-shrink: 0; color: #B7791F; }
`;
